import { render, staticRenderFns } from "./DefaultContainerV2.vue?vue&type=template&id=6a42f944&"
import script from "./DefaultContainerV2.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports